import React from "react";

const NoCliniciansPlaceholder = () => {

    return (
        <div className="d-flex align-items-center justify-content-center no-coupons">
            <div className="d-flex flex-column align-items-center">
                <label className="font-size-16 mt-4 no-coupons-label ">No created Clinicians yet</label>
            </div>
        </div>
    )
}

export default NoCliniciansPlaceholder;